var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[(_vm.isTrial || (_vm.payingCustomer && _vm.accountActive))?_c('CurrentSubscription',{attrs:{"trial":_vm.isTrial,"subscribed":_vm.payingCustomer}}):_vm._e(),(!_vm.payingCustomer || !_vm.accountActive)?_c('AvailableSubscriptions'):_vm._e(),_c('Billing'),_c('Coupon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }